import { render, staticRenderFns } from "./PictureListPage.vue?vue&type=template&id=d84257bc&"
import script from "./PictureListPage.vue?vue&type=script&lang=js&"
export * from "./PictureListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports